import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import schema from "@components/faqSchema/whatsapp-business-api-guide-for-real-estate-download-free-e-book.json";
import NewLayout from "@components/new-ui/Layout";
import Head from "next/head";
import Image from "next/image";

const scriptText = JSON.stringify(schema, null, 2);

const HeroSectionData: HeroSectionProps = {
    title: "The Complete Guide to WhatsApp for Real Estate Businesses",
    listHeading: "Leverage the power of WhatsApp (the Business API version) for your real estate business. It packs powerful automation features that will:",
    listText: [
        { label: "Enable real-time, two-way communication with your (potential) customers" },
        { label: "Help set up your entire marketing and sales funnel on WhatsApp" },
        { label: "Provide you with the best channel to convert leads to deals" },
    ],
    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/e-book/hero-image.png",
    altMedia: "gallabox-e-book",
    ebookName: "real-estate-ebook",
};

const EBook: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Guide for Real Estate Businesses - Download Free E-book | Gallabox"
            description="Learn how to use WhatsApp Business API for real estate. Download Gallabox’s free e-book guide to WhatsApp for real estate businesses to discover powerful automation features, lead generation, and communication strategies for property developers, agencies, brokers, and more."
            canonical="https://gallabox.com/resources/whatsapp-for-real-estate-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/wa-for-real-estate-ebook-og.png" }}
            keywords="whatsapp for real estate free e-book, download whatsapp business api guide for real estate, whatsapp for real estate businesses, whatsapp guide for property developers, whatsapp guide for real estate marketing, gallabox’s guide for real estate"
            schema={{
                heroOrOgImageAlt: "real-estate-industry-image",
                heroOrOgImageDescription: "Scale your real estate property visits by 100% with WhatsApp automation",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/e-book/hero-image.png",
            }}
        >
            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: scriptText }} />
            </Head>
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">
                            Trusted by over <span className="font-bold">10,000 companies</span> across <span className="font-bold">40+ </span> countries
                        </h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/e-book/logo-image.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/e-book/logo-image.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EBook;
